"use strict";

function siteFAQ() {
  var el = document.querySelectorAll('.js-faq');

  if (el) {
    el.forEach(function (faqItem) {
      faqItem.classList.remove('c-faq__item--open');
      var faqToggle = faqItem.querySelector('.c-faq__item__question');

      if (faqToggle) {
        faqToggle.addEventListener('click', function (e) {
          e.currentTarget.parentElement.classList.toggle('c-faq__item--open');
        });
      }
    });
  }
}

siteFAQ();